(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    if (root.dataset.unlockInitialized) return;
    root.dataset.unlockInitialized = 'true';
    const cards = [...root.querySelectorAll('[data-week]')];
    const states = new WeakMap(cards.map(card => [card, card.dataset.state]));
    const key = `mkal-seen-weeks:${root.dataset.project}`;
    let seen = null;
    try { seen = JSON.parse(sessionStorage.getItem(key)); } catch {}
    function remember() {
      try { sessionStorage.setItem(key, JSON.stringify(cards.filter(c => c.dataset.state === 'available').map(c => Number(c.dataset.week)))); } catch {}
    }
    const pending = new WeakSet();
    function play(card) {
      pending.delete(card);
      if (card.dataset.state !== 'available' || reduced.matches) return;
      card.classList.remove('mkal-unlocking');
      void card.offsetWidth;
      card.classList.add('mkal-unlocking');
      setTimeout(() => card.classList.remove('mkal-unlocking'), 1400);
    }
    const visible = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        visible.unobserve(entry.target);
        play(entry.target);
      }
    }, {threshold: 0.35});
    function queue(card) {
      if (reduced.matches || pending.has(card)) return;
      pending.add(card);
      visible.observe(card);
    }
    const available = cards.filter(c => c.dataset.state === 'available');
    const newlyAvailable = Array.isArray(seen) ? available.filter(c => !seen.includes(Number(c.dataset.week))) : available.slice(-1);
    newlyAvailable.forEach(queue);
    remember();
    const observer = new MutationObserver(() => {
      for (const card of cards) {
        const current = card.dataset.state;
        if (states.get(card) === 'locked' && current === 'available') queue(card);
        if (current === 'locked') card.classList.remove('mkal-unlocking');
        states.set(card, current);
      }
      remember();
    });
    cards.forEach(card => observer.observe(card, {attributes:true, attributeFilter:['data-state']}));
  }
  document.querySelectorAll('[data-mkal]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mkal]').forEach(init));
})();
